export default __webpack_public_path__ + "static/media/group62-mobile.ac3b6a44.png";